'use client';

import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useGetUser } from '@/queries/user';
import Toast from '@/components/Toast';
import { useFlag } from '@/unleash';
import { registerChatScript, restoreChatVisibility } from './utils/Chat.script';
import { useSetChatData } from './utils/Chat.utils';

const ChatContainer: FC<PropsWithChildren> = ({ children }) => {
  const flag = useFlag('web.general.chatBot');
  const isEnabled = flag.isEnabled && flag.isReady;
  const setChatData = useSetChatData();
  const { data: user, isLoading: isUserLoading } = useGetUser({
    notifyOnChangeProps: ['data', 'isLoading'],
  });

  useEffect(() => {
    setChatData({ isEnabled });

    if (!isEnabled || isUserLoading) return;

    registerChatScript({
      onChatReady: (setUserInfo) => {
        if (user) setUserInfo(user as any);
        setChatData({ isReady: true });
      },
      onError: () => {
        setChatData({ isError: true });
      },
      onWidgetShown: () => {
        setChatData({ isVisible: true, totalUnread: 0 });
      },
      onWidgetHidden: () => {
        setChatData({ isVisible: false });
      },
      onMessage: ({ isShown, totalUnread }) => {
        if (!isShown) {
          setChatData({ totalUnread });
          Toast.open({
            isDismissible: false,
            hasIcon: false,
            variant: 'info',
            duration: 20 * 1000,
            children: (
              <div className="flex w-full">
                <div>یک پیام از پشتیبانی دریافت شد.</div>
                <a
                  className="mr-2 cursor-pointer font-bold"
                  onClick={() => restoreChatVisibility()}
                >
                  مشاهده
                </a>
              </div>
            ),
          });
        }
      },
    });
  }, [isEnabled, isUserLoading]);

  return <>{children}</>;
};

export default ChatContainer;
